<template>
  <hm-content title="预约活动发券列表">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" plain size="small" @click="addActivity"
          >新增发券</el-button
        >
      </div>
      <div>
        <el-date-picker
          v-model="applyDate"
          type="datetimerange"
          align="right"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="报名开始时间"
          end-placeholder="报名结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-select
          clearable
          v-model="actStatus"
          placeholder="活动状态"
          size="small"
          filterable
          class="mr10"
        >
          <el-option label="开启" value="1"></el-option>
          <el-option label="关闭" value="0"></el-option>
        </el-select>
        <el-input
          clearable
          v-model.trim="actName"
          placeholder="输入活动名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        ref="table"
        stripe
        border
        :data="subCouponLogList.records"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          label="序号"
          type="index"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          prop="actName"
          align="center"
          label="活动名称"
        >
          <template slot-scope="scope">
            <div class="table-status flex item-center">
              <span
                class="status success-bg"
                v-show="scope.row.timeStatus === 'running'"
              ></span>
              <span
                class="status gray-bg"
                v-show="scope.row.timeStatus === 'notStart'"
              ></span>
              <span
                class="status danger-bg"
                v-show="scope.row.timeStatus === 'end'"
              ></span>
              <span class="flex flex-1 flex-start">
                {{ scope.row.actName }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="300px"
          prop="couponType"
          label="发放类型"
        >
          <template slot-scope="scope">
            <span v-show="scope.row.couponType === 'share'">分享发券</span>
            <span v-show="scope.row.couponType === 'buy'">购买发券</span>
            <span v-show="scope.row.couponType === 'check'">核销发券</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="ruleName"
          label="发放内容"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="发放时间"
        ></el-table-column>
        <el-table-column
          label="操作"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="编辑" placement="top">
                <div
                  v-if="scope.row.timeStatus !== 'end'"
                  class="pointer mr10"
                  @click="edit(scope.row)"
                  v-show="scope.row.auditState !== 'audit_pass'"
                >
                  <span class="hmicon icon-bianji blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="删除" placement="top">
                <div
                  class="pointer"
                  @click="remove(scope.row)"
                  v-show="
                    scope.row.auditState !== 'audit_pass' ||
                      (scope.row.auditState === 'audit_pass' &&
                        scope.row.actStatus === 'disabled')
                  "
                >
                  <span class="hmicon icon-shanchu primary"></span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <hm-status />
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="subCouponLogList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>

    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
      @close="resetForm('ruleForm')"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="活动名称" prop="subActId">
          <el-select
            @change="selectAct"
            clearable
            v-model="ruleForm.subActId"
            placeholder="选择活动"
            size="small"
            filterable
            :disabled="mode === 'edit'"
            class="mr10 multiple-select"
          >
            <el-option
              v-for="item in subCouponLog"
              :key="item.id"
              :label="item.actName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发券类型" prop="couponType">
          <el-select
            clearable
            v-model="ruleForm.couponType"
            @change="switchCouponType"
            placeholder="选择类型"
            size="small"
            filterable
            class="mr10 multiple-select"
          >
            <el-option label="分享发券" value="share"></el-option>
            <el-option label="购买发券" value="buy"></el-option>
            <el-option label="核销发券" value="check"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发放券包" prop="couponRuleIds">
          <el-select
            clearable
            v-model="ruleForm.couponRuleIds"
            placeholder="选择券包(可多选)"
            multiple
            :disabled="!ruleForm.couponType"
            size="small"
            filterable
            class="mr10 multiple-select"
          >
            <el-option
              v-for="item in couponPackages"
              :key="item.couponSendId"
              :label="item.name"
              :value="item.couponSendId"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button size="small" @click="resetForm('ruleForm')"
            >返回</el-button
          >
        </div>
      </el-form>
    </el-dialog>
  </hm-content>
</template>

<script>
import HmStatus from "@/components/HmStatus";
import moment from "moment";
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  components: { HmStatus },
  data() {
    return {
      title: "",
      applyDate: [],
      activityChildCategoryList: [],
      currentPage: 1,
      startDate: "",
      endDate: "",
      pageSize: 10,
      date: [],
      promotionCode: "",
      actName: "",
      mode: "",
      currentRowId: "",
      actStatus: "",
      auditState: "",
      isOutputing: false,
      dialogFormVisible: false,
      ruleForm: {
        subActId: "",
        couponType: "",
        couponRuleIds: []
      },
      rules: {
        subActId: {
          required: true,
          message: "请选择活动",
          trigger: "change"
        },
        couponType: {
          required: true,
          message: "请选择发券类型",
          trigger: "change"
        },
        couponRuleIds: [
          {
            required: true,
            message: "请选择券包",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {},
  mounted() {
    this.getParamsCookie();
    this.queryList();
  },
  computed: mapGetters([
    "subCouponLogList",
    "subCouponLog",
    "allSubCouponLogList",
    "couponPackages"
  ]),
  watch: {
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    },
    dateAndTime(val) {
      this.startDate = val ? moment(val[0]).format("YYYY-MM-DD HH:mm:ss") : "";
      this.endDate = val ? moment(val[1]).format("YYYY-MM-DD HH:mm:ss") : "";
    },
    "subCouponLogList.total": {
      handler(val) {
        if (
          val == (this.currentPage - 1) * this.pageSize &&
          this.pageTotal != 0
        ) {
          this.currentPage -= 1;
          this.queryList();
        }
      },
      deep: true
    }
  },
  methods: {
    selectAct() {
      this.ruleForm.couponType = "";
      this.ruleForm.couponRuleIds = [];
    },
    switchCouponType() {
      if (this.ruleForm.couponType) {
        this.$store.dispatch("queryCouponPackages", {
          couponType: this.ruleForm.couponType
        });
        this.ruleForm.couponRuleIds = [];
      }
    },
    addActivity() {
      this.dialogFormVisible = true;
      this.mode = "add";
      this.title = "新增发券";
      this.$store.dispatch("addSubCouponLogs");
    },
    edit(row) {
      this.dialogFormVisible = true;
      this.currentRowId = row.id;
      this.title = "编辑发券";
      this.mode = "edit";
      this.$store.dispatch("addSubCouponLogs").then(() => {
        this.ruleForm.subActId = row.subActId;
        this.ruleForm.couponType = row.couponType;
        this.$store
          .dispatch("queryCouponPackages", {
            couponType: this.ruleForm.couponType
          })
          .then(() => {
            this.ruleForm.couponRuleIds = row.couponRuleIds
              .split(";")
              .map(o => o);
          });
      });
    },
    submitForm(formName) {
      let params = {
        subActId: this.ruleForm.subActId,
        couponType: this.ruleForm.couponType,
        couponRuleIds: this.ruleForm.couponRuleIds.join(";")
      };
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.mode === "add") {
            this.$store.dispatch("saveSendCouponPackages", params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.dialogFormVisible = false;
                this.queryList();
              }
            });
          } else {
            params = Object.assign(params, {
              id: this.currentRowId
            });
            this.$store.dispatch("editSubCouponLog", params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.dialogFormVisible = false;
                this.queryList();
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      for (let key in this.ruleForm) {
        this.ruleForm[key] = "";
      }
      this.ruleForm.storeOutletIds = [];
      this.ruleForm.isShow = 1;
      this.dialogFormVisible = false;
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(res => {
            const list = res.result.records;
            list.forEach(v => {
              if (v.couponType === "share") {
                v.couponType = "分享发券";
              } else if (v.couponType === "buy") {
                v.couponType = "购买发券";
              } else if (v.couponType === "check") {
                v.couponType = "核销发券";
              }
            });
            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);

            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }

            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "预约活动发券列表" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("delSubCouponLog", {
            id: row.id
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    queryList() {
      this.setParamsCookie();
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        actName: this.actName,
        actStatus: this.actStatus
      };
      params.applyStartTime =
        this.applyDate && this.applyDate.length > 0 ? this.applyDate[0] : null;
      params.applyEndTime =
        this.applyDate && this.applyDate.length > 0 ? this.applyDate[1] : null;
      return this.$store.dispatch("subCouponLogList", params);
    },
    setParamsCookie() {
      let searchCondition = {
        actName: this.actName,
        actStatus: this.actStatus,
        applyDate: this.applyDate
      };
      setCookie({
        key: "viewReservitionCouponManagermentParams",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({
        key: "viewReservitionCouponManagermentParams",
        type: "session"
      });
      if (prams) {
        this.applyDate = prams.applyDate;
        this.actName = prams.actName;
        this.actStatus = prams.actStatus;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    queryAllList() {
      const params = {
        pageSize: 999999,
        pageNo: 1,
        actName: this.actName,
        actStatus: this.actStatus
      };
      params.applyStartTime =
        this.applyDate && this.applyDate.length > 0 ? this.applyDate[0] : null;
      params.applyEndTime =
        this.applyDate && this.applyDate.length > 0 ? this.applyDate[1] : null;
      return this.$store.dispatch("allSubCouponLogList", params);
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss">
.btn.active {
  background: #71abff;
  color: #fff;
  border-radius: 5px;
}
.btn-group {
  margin-bottom: 2rem;
}

.status {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 10px;
  margin-top: -2px;
}
</style>
